<template>
  <div class="productInfo">
    <div class="box">
      <h4>专属客服</h4>
      <ul>
        <li>XXXXXXXXXXXXXXXXXX</li>
        <li>XXXXXXXXXXXXXXXXXX</li>
        <li>XXXXXXXXXXXXXXXXXX</li>
        <li>XXXXXXXXXXXXXXXXXX</li>
        <li>XXXXXXXXXXXXXXXXXX</li>
      </ul>
<!--      <img class="img-thumbnail yuanjiao" :src="imgUrl+'/images/heibai.jpg!ty'">-->
    </div>
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';

export default {
  name: 'productInfo',
  props:['obj'],
  mixins: [generalMix],
  data () {
    return {
    }
  },
  methods:{
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>

.productInfo {
  box-shadow: 0 0 1.5rem rgba(18, 38, 63, .1);
  color: #000000;
  background: #FFFFFF;
  width: 480px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
  border-radius: 1rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  overflow-y: hidden;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  /*通用滚动条样式*/
  div.box{
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    h4{
      line-height: 5em;
      border-bottom: 1px solid #EFF2F7;
      margin-bottom: 50px;
    }
    img{
      width: 80%;
    }
  }
}
@media (max-width: 767px) {
  .productInfo {
    width: 80vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/wechat.vue